import { z } from 'zod';
export var BusinessHoursClassification;
(function (BusinessHoursClassification) {
    BusinessHoursClassification["IN_HOURS"] = "in_hours";
    BusinessHoursClassification["AFTER_HOURS"] = "after_hours";
    BusinessHoursClassification["UNKNOWN"] = "unknown";
})(BusinessHoursClassification || (BusinessHoursClassification = {}));
export var BusinessHoursClassificationReason;
(function (BusinessHoursClassificationReason) {
    BusinessHoursClassificationReason["WITHIN_INTERVAL"] = "within_interval";
    BusinessHoursClassificationReason["OUTSIDE_INTERVAL"] = "outside_interval";
    BusinessHoursClassificationReason["DAY_CLOSED"] = "day_closed";
    BusinessHoursClassificationReason["SCHEDULE_NOT_CONFIGURED"] = "schedule_not_configured";
    BusinessHoursClassificationReason["TIMEZONE_NOT_CONFIGURED"] = "timezone_not_configured";
    BusinessHoursClassificationReason["INVALID_TIMEZONE"] = "invalid_timezone";
    BusinessHoursClassificationReason["INVALID_TIMESTAMP"] = "invalid_timestamp";
})(BusinessHoursClassificationReason || (BusinessHoursClassificationReason = {}));
export const localTimeSchema = z
    .string()
    .regex(/^([01]\d|2[0-3]):[0-5]\d$/, 'Must be a 24-hour HH:MM time');
/** Open boundary is inclusive, close boundary is exclusive; overnight intervals are deferred (ENG-3421). */
export const businessHoursIntervalSchema = z
    .object({
    open: localTimeSchema,
    close: localTimeSchema,
})
    .refine(interval => interval.open < interval.close, {
    message: 'Opening time must be before closing time',
});
/** Multiple intervals per day (split shifts) are deferred (ENG-3421); relax the cap to enable them. */
export const businessHoursDaySchema = z
    .array(businessHoursIntervalSchema)
    .max(1, 'At most one interval per day is supported')
    .nullable();
/** All seven weekdays are required; null or an empty array marks a day as closed. */
export const weeklyBusinessHoursSchema = z.object({
    monday: businessHoursDaySchema,
    tuesday: businessHoursDaySchema,
    wednesday: businessHoursDaySchema,
    thursday: businessHoursDaySchema,
    friday: businessHoursDaySchema,
    saturday: businessHoursDaySchema,
    sunday: businessHoursDaySchema,
});
//# sourceMappingURL=business-hours.js.map